import PropTypes from 'prop-types'
import React from 'react'

// dangerouslySetInnerHTML={{ __html: content }}
const TopBanner = ({ content }) => {
  return <div className='top-banner center'>{content}</div>
}

TopBanner.propTypes = {
  content: PropTypes.string.isRequired
}

export default TopBanner



// WEBPACK FOOTER //
// ./frontend/scripts/react/components/TopBanner.js